import { HeaderVariant } from "./types";
import { BasicRoutePath } from "@/constants";

export const getHeaderVariant = (pathname: string): HeaderVariant => {
  if (pathname.startsWith(BasicRoutePath.Approvals)) {
    return HeaderVariant.Gray;
  }

  return HeaderVariant.Transparent;
};
